module.exports = {"TXTWCL_Player_Funds_Protection":{"id":"TXTWCL_Player_Funds_Protection","defaultMessage":"Protección de fondos de jugadores"}}